import { render, staticRenderFns } from "./BalanceSheetReport.vue?vue&type=template&id=963f439e&"
import script from "./BalanceSheetReport.vue?vue&type=script&lang=js&"
export * from "./BalanceSheetReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports